import { ChangeDetectionStrategy, Component } from '@angular/core';
import { title } from '@softline/application';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'soft-rohstoffbilanz',
  imports: [RouterModule],
  templateUrl: './rohstoffbilanz.component.html',
  styleUrls: ['./rohstoffbilanz.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export default class RohstoffbilanzComponent {
  constructor() {
    title('Rohstoffbilanz');
  }
}
